export default __webpack_public_path__ + "static/media/template27.10001195.svg";